import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../Theme/theme';

export const styleSheet = StyleSheet.create({
	credit: {
		alignItems: 'center',
		color: THEME.colors.text.light,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.xs,
		gap: SPACE[8],
	},
	group: {
		flexWrap: 'wrap',
	},
	/** The row across the top of the box, ruled off from the text like the rest of the box. */
	toolbar: {
		borderBottom: `1px solid ${THEME.colors.border.main}`,
		padding: `${SPACE[8]}px ${SPACE[8]}px`,
	},
	toolbarEnd: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[4],
		marginLeft: 'auto',
	},
});
